import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-item",
  "use": "icon-check-item-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check-item\">\n<path d=\"M11.3463 1.29944C7.60101 3.61724 5.1383 7.40094 5.1385 11.7006C5.1385 9.24494 3.5405 7.03804 1 5.51684\" stroke=\"#0B5CFF\" stroke-width=\"2.0157\" stroke-linejoin=\"bevel\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol